<template>
  <div class="card block">
    <header class="card-header">
      <div class="is-size-4 card-header-title"><span class="material-icons accent-color">account_circle</span>被保険者{{ insuredNum }}</div>
    </header>
    <div class="card-content">
      <div class="columns">
        <div class="column is-4">
          <p class="mb-0">氏名</p>
        </div>
        <div class="column is-7">
          <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="props.tf_khhksj" />
        </div>
      </div>
      <div class="columns">
        <div class="column is-4">
          <p class="mb-0">氏名（フリガナ）</p>
        </div>
        <div class="column is-7">
          <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="props.tf_khhksk" />
        </div>
      </div>
      <div class="columns">
        <div class="column is-4">
          <p class="mb-0">生年月日</p>
        </div>
        <div class="column is-7">
          <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="props.tf_khhkbt" />
        </div>
      </div>
      <div class="columns">
        <div class="column is-4">
          <p class="mb-0">性別</p>
        </div>
        <div class="column">
          <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="getGenderText(props.tf_khhksx)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import HyphenParagraph from "common/src/components/HyphenParagraph.vue";
import { getGenderText } from "common/src/utils/codes";

export default defineComponent({
  components: {
    HyphenParagraph,
  },
  props: {
    /** 被保険者番号 */
    tf_khhkno: {
      type: String,
      required: true,
    },
    /** 被保険者名漢字 */
    tf_khhksj: {
      type: String,
      required: true,
    },
    /** 被保険者名カナ */
    tf_khhksk: {
      type: String,
      required: true,
    },
    /** 被保険者生年月日 */
    tf_khhkbt: {
      type: String,
      required: true,
    },
    /** 被保険者性別 */
    tf_khhksx: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const insuredNum = Number.parseInt(props.tf_khhkno);

    return {
      insuredNum,
      props,
      getGenderText,
    };
  },
});
</script>
